import * as React from 'react';
import DetailsContainer from '../../components/tables/DetailsContainer';
import DetailsBlock from '../../components/tables/DetailsBlock';
import { localizations } from '../../localization/localization';
import { RegisteredCompanyDataModel } from '../models/CompanyModels';
import { DetailsValueBlock } from '../../components/tables/DetailsValueBlock';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { renderEmailDetails, renderContactPersonDetails, renderAddressDetails, renderPhoneDetails, renderDescriptionDetails, renderIndustryTypeDetails } from '../../components/tables/DetailsHelpers';

type RejectedCompanyInformationProps = RegisteredCompanyDataModel & DeleteCompanyProps;

interface DeleteCompanyProps {
    deleteCompany: (companyId: string) => void
}

const RejectedCompanyInformation: React.SFC<RejectedCompanyInformationProps> = ({
    deleteCompany,
    id,
    name,
    address,
    phoneContacts,
    emailContacts,
    contactPerson,
    website,
    description,
    industryType
}) => {

    const handleDeleteCompanyClick = (companyId: string) => (event: any) => deleteCompany(companyId);  

    return <DetailsContainer>
        <DetailsBlock title={localizations.admin.rejectedCompanyInformationHeader} rightItems={
            <Grid container spacing={2}>
                <Grid item>
                    <Button variant="outlined" color="secondary" onClick={handleDeleteCompanyClick(id)}>
                        {localizations.actions.delete}
                    </Button>
                </Grid>
            </Grid>}>
            <DetailsValueBlock title={localizations.common.companyName}>
                <Typography>{name}</Typography>
            </DetailsValueBlock>
            {renderAddressDetails(address)}
            {phoneContacts.map((item, index) => <React.Fragment key={index}>
                {renderPhoneDetails(item)}
            </React.Fragment>)}
            {emailContacts.map((item, index) => <React.Fragment key={index}>
                {renderEmailDetails(item)}
            </React.Fragment>)}
            {renderContactPersonDetails(contactPerson)}
            <DetailsValueBlock title={localizations.common.website}>
                <Typography>{website}</Typography>
            </DetailsValueBlock>
            {renderIndustryTypeDetails(industryType)}
            {renderDescriptionDetails(description)}
        </DetailsBlock>
    </DetailsContainer>
}

export default RejectedCompanyInformation;


// WEBPACK FOOTER //
// ./src/admin/companies/RejectedCompanyInformation.tsx